// @ts-nocheck

import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import { TABBAR_ITEM_TRANSITION } from '../../../constants/ui/tabbar';
import { MPLogoNav } from '../assets/svg';

const bounceAnimation = keyframes`
  47% {
    transform: scale(1);
    filter: brightness(100%);
  }

  50% {
    transform: scale(1.2);
    filter: brightness(200%);
  }

  53% {
    transform: scale(1);
    filter: brightness(100%);
  }
`;

const Wrapper = styled.div`
  width: 2em;
  height: 2em;
  margin: 0;
  padding: 0;

  position: relative;
  overflow: hidden;

  transition: filter ${TABBAR_ITEM_TRANSITION}ms ease-in-out;

  ${({ $animate }) => css`
    ${$animate
      ? css`
          animation: ${bounceAnimation} 3000ms ease-in-out infinite;
        `
      : undefined}
  `}
`;

const StyledFullSvg = styled(MPLogoNav)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 100%;

  z-index: 1;
`;

type MPIconProps = {
  className?: string;
  disableAnimation?: boolean;
};

const MPIcon = ({ className = '', disableAnimation = false }: MPIconProps) => {
  return (
    <Wrapper className={className} $animate={!disableAnimation}>
      <StyledFullSvg />
    </Wrapper>
  );
};

export default MPIcon;
